/**
 * Shared configuration for user warnings React Query hooks
 */

/**
 * 24 hours in milliseconds
 * Used for caching user warnings data since it rarely changes
 */
export const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;

/**
 * Default React Query options for user warnings endpoints
 * Provides caching since user warnings data rarely changes
 */
export const USER_WARNINGS_QUERY_CONFIG = {
  staleTime: TWENTY_FOUR_HOURS_MS,
  gcTime: TWENTY_FOUR_HOURS_MS,
} as const;
